import { FetchUtil } from "../util/FetchUtil";
import { IUserGoalsUpdateResponse } from "../models/UserGoals/IUserGoalsUpdateResponse";
import { IUserGoalsUpdateRequest } from "../models/UserGoals/IUserGoalsUpdateRequest";
import { IUserGoalsServiceEndpoint } from "../models/UserGoals/IUserGoalsServiceEndpoint";
export class UserGoalsService {
  constructor(private readonly _endpoint: IUserGoalsServiceEndpoint) {
  }

  public async update(req: IUserGoalsUpdateRequest): Promise<IUserGoalsUpdateResponse> {
    const endpoint = this._endpoint.update;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const body = {
      contactid: req.contactid,
      credits : req.credits,
      startdate: req.startdate,
      enddate: req.enddate,
      reminders : req.reminders
    };

    const url = endpoint.url;

    const result = await FetchUtil
      .sendMessage({ method: endpoint.method, url }, body, "default", false);

    const response = result as IUserGoalsUpdateResponse;

    return response;
  }
}